import { ApplicationRef, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgPipesModule } from 'angular-pipes';
import { ModalModule } from 'ngx-bootstrap/modal';

import { AuthGuard } from './_guards/auth.guard';
import { AppComponent } from './app.component';
import { APP_RESOLVER_PROVIDERS } from './app.resolver';
import { routing } from './app.routing';
import { AppState } from './app.service';
import { CoreModule } from './core/core.module';
import { I18nPipeModule } from './shared/_utils/pipes/i18nPipe.module';
import { SmartadminLayoutModule } from './shared/layout/layout.module';


// import * as $ from 'jquery';
/* Pipe */
/*
 * Platform and Environment providers/directives/pipes
 */
// App is our top level component
// Core providers
// Application wide providers
const APP_PROVIDERS = [
  ...APP_RESOLVER_PROVIDERS,
  AppState
];

// type StoreType = {
//   state: InternalStateType,
//   restoreInputValues: () => void,
//   disposeOldHosts: () => void
// };

/**
 * `AppModule` is the main entry point into Angular2's bootstraping process
 */
@NgModule({
  bootstrap: [ AppComponent ],
  declarations: [
    AppComponent
  ],

  imports: [ // import Angular's modules
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ModalModule.forRoot(),
    NgPipesModule,
    I18nPipeModule,
    CoreModule,
    SmartadminLayoutModule,
    routing
  ],
  exports: [

  ],
  providers: [ // expose our Services and Providers into Angular's dependency injection
    // ENV_PROVIDERS,
    APP_PROVIDERS,
    AuthGuard
  ]
})

export class AppModule {
  constructor(public appRef: ApplicationRef, public appState: AppState) {}


}




// WEBPACK FOOTER //
// ./src/app/app.module.ts